import { render, staticRenderFns } from "./PC.vue?vue&type=template&id=77f8b1d2&scoped=true"
import script from "./PC.vue?vue&type=script&lang=js"
export * from "./PC.vue?vue&type=script&lang=js"
import style0 from "./PC.vue?vue&type=style&index=0&id=77f8b1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f8b1d2",
  null
  
)

export default component.exports